import React from "react";

class LoginPanel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            balances: {},
            userContext: {},
            balanceVisible: GBEglobal.settings.isBalanceVisible !== undefined ? GBEglobal.settings.isBalanceVisible.display : false,
            initPreferences: GBEglobal.preferences,
            showLoginWidget: false
        };

        this.refreshBalances = this.refreshBalances.bind(this);
        this.setBalancesIfBlank = this.setBalancesIfBlank.bind(this);
        this.handleAccountsClick = this.handleAccountsClick.bind(this);
        this.toggleBalance = this.toggleBalance.bind(this);
        this.updateBalanceStorage = this.updateBalanceStorage.bind(this);
    }

    showLoginWidget(value) {
        GBEglobal.logger.log({ hitType: "event", eventCategory: "login-panel", eventAction: "click", eventLabel: value });
        this.setState({
            showLoginWidget: true
        }, () => {
            this.props.onLoginWidgetShow(this.state.showLoginWidget);
        });
    }

    componentDidMount() {
    }

    componentDidUpdate(prevProps) {
        if (JSON.stringify(this.props.userContext) !== JSON.stringify(prevProps.userContext)) {
            this.setState({
                userContext: this.props.userContext
            }, () => {
                const balanceVisible = GBEglobal.preferences.displayBalance !== undefined ? GBEglobal.preferences.displayBalance : this.state.balanceVisible;

                if (window.localStorage.isBalanceVisible === undefined && this.props.userContext) {
                    this.updateBalanceStorage(balanceVisible);
                }

                const localStorageBalance = window.localStorage.isBalanceVisible;
                if (localStorageBalance !== undefined && JSON.parse(localStorageBalance) && this.props.userContext) {
                    this.refreshBalances({ showBalance: true });
                }
            });
        }
    }

    getBalances() {
        return this.state.balances;
    }

    refreshBalances(params) {
        GBEglobal.logger.log({ hitType: "event", eventCategory: "login-panel", eventAction: "click", eventLabel: "refresh-balance" });
        const thisComponent = this;
        if (window.localStorage.isBalanceVisible || params !== undefined && params.showBalance) {
            thisComponent.props.controller.getBalance({
                callbackOnSuccess: function callbackOnSuccess(resp) {
                    const newState = {};
                    newState.balances = resp;
                    if (params !== undefined && params.showBalance) {
                        thisComponent.updateBalanceStorage(true);
                    }

                    thisComponent.setState(newState);
                },
                callbackOnException: function callbackOnException(resp) {
                    console.error(resp);
                }
            });
        }

    }

    setBalancesIfBlank() {
        const thisComponent = this;
        if (!thisComponent.state.balances || typeof thisComponent.state.balances.availableBalance === "undefined") {
            thisComponent.props.controller.getBalance({
                callbackOnSuccess: function callbackOnSuccess(resp) {
                    const newState = {};
                    newState.balances = resp;
                    thisComponent.setState(newState);
                },
                callbackOnException: function callbackOnException(resp) {
                    console.error(resp);
                }
            });
        }
    }

    toggleBalance(value) {
        const thisComponent = this;
        const isBalanceVisible = JSON.parse(window.localStorage.isBalanceVisible);
        GBEglobal.logger.log({ hitType: "event", eventCategory: "login-panel", eventAction: "click", eventLabel: value });

        thisComponent.updateBalanceStorage(!isBalanceVisible);

        if (!isBalanceVisible) {
            this.refreshBalances({ showBalance: true });
        } else {
            thisComponent.setState({
                balanceVisible: !isBalanceVisible
            });
        }

    }

    handleLogout(value) {
        GBEglobal.logger.log({ hitType: "event", eventCategory: "login-panel", eventAction: "click", eventLabel: value });
        this.props.onLogoutRequest();
    }

    handleAccountsClick(page) {
        GBEglobal.logger.log({ hitType: "event", eventCategory: "login-panel", eventAction: "click", eventLabel: page });
        this.props.onAccountClicked(page);
    }

    updateBalanceStorage(isBalanceVisible) {
        window.localStorage.setItem("isBalanceVisible", isBalanceVisible);
    }

    render() {
        const cSymbol = GBEUtils.getCurrencySymbol(GBEglobal.currency);
        const isBalanceVisible = window.localStorage.isBalanceVisible ? JSON.parse(window.localStorage.isBalanceVisible) : false;

        if (window.canHaveSession !== true) {
            return (<div></div>);
        }

        const embedded = window !== top;

        const loginJoinMobileText = configurationSettings.whiteLabel.toLocaleLowerCase() === "betdaq" ? "Login / Join" : "Log In / Join Now";
        return (
            <div id="loginPanel" className="order-md-last">
                {this.props.userContext !== undefined &&
                    <div>
                        <span id="btnBalance">
                            <button className="btn btn-primary" onClick={this.toggleBalance.bind(this, "balance")}>
                                {!isBalanceVisible && <>Balance</>}
                                {this.state.balances.balance !== undefined && isBalanceVisible &&
                                    <>
                                        <span className="balanceLabel">Balance</span>
                                        <span className="balance" dangerouslySetInnerHTML={{ __html: GBEUtils.formatDecimal(this.state.balances.balance, 2, cSymbol, true) }} />
                                    </>
                                }
                            </button>

                            {this.state.balances.balance !== undefined && isBalanceVisible &&
                                <span className="material-icons refresh-balance ml-1" onClick={this.refreshBalances}>refresh</span>
                            }
                        </span>
                        {!embedded &&
                            <button id="deposit" className="btn btn-primary ml-1" onClick={this.handleAccountsClick.bind(this, "ftm/deposit")}>Deposit</button>
                        }

                        <button id="my-bets" className="btn btn-primary ml-1" onClick={this.handleAccountsClick.bind(this, "current-bets")}>My Bets</button>
                        {!embedded &&
                            <button id="btnLogout" className="btn btn-secondary ml-1 d-none d-md-inline-block" onClick={this.handleLogout.bind(this, "logout")}>Log Out</button>
                        }
                    </div>
                }
                {this.props.userContext === undefined && !embedded &&
                    <div className="row">
                        <div className="col-md-12 buttonsWrapper">
                            <button id="btnLogin" onClick={this.showLoginWidget.bind(this, "login")} className="btn btn-primary ml-1">
                                <span className="desktop-login-text">Log In</span>
                                <span className="mobile-login-text">{loginJoinMobileText}</span>
                            </button>
                            <button id="btnJoin" onClick={this.handleAccountsClick.bind(this, "joinnow")} className="btn btn-primary ml-1 btn-join d-none d-md-inline-block">Join Now</button>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

export { LoginPanel };